// Module
var code = "You should try to find somewhere to sit in a place that you think of as busy, a thoroughfare of some kind, maybe between two buildings..<br> Press ‘I’m there’ when you are. ";
// Exports
module.exports = code;